import React,{useState}from"react";
import{Button,CircularProgress}from"@mui/material";
import PrintRoundedIcon from"@mui/icons-material/PrintRounded";
import{useDashboardTheme}from"../../../context/DashboardThemeContext";
import{useAlert}from"../../../context/AlertContext";

const PRINT_INVOICE_ENDPOINT="http://127.0.0.1:5050/print-invoice";

function txt(value){
  return String(value??"").trim();
}

function normalizePrintData(factura){
  const empresa=factura?.empresa||{};
  const nombreEmpresa=txt(empresa.nombre_comercial)||txt(empresa.razon_social);
  const sistema=txt(factura?.sistema);
  const rucProveedor=txt(factura?.ruc_proveedor);
  const informacionAdicional=(factura?.informacion_adicional||[])
    .filter(item=>!["SISTEMA","RUC PROVEEDOR"].includes(txt(item?.nombre).toUpperCase()))
    .map(item=>({nombre:txt(item?.nombre),valor:txt(item?.valor)}))
    .filter(item=>item.nombre&&item.valor);

  if(sistema)informacionAdicional.push({nombre:"SISTEMA",valor:sistema});
  if(rucProveedor)informacionAdicional.push({nombre:"RUC PROVEEDOR",valor:rucProveedor});

  const payload={
    ...factura,
    empresa:{
      ...empresa,
      nombre_centrado:nombreEmpresa
    },
    empresa_nombre_centrado:nombreEmpresa,
    clave_acceso:txt(factura?.clave_acceso),
    sistema,
    ruc_proveedor:rucProveedor,
    informacion_adicional:informacionAdicional,
    impresion:{
      empresa_centrada:nombreEmpresa,
      mostrar_clave_acceso:true,
      mostrar_numero_autorizacion:false,
      informacion_adicional_centrada:[
        ...(sistema?[{nombre:"SISTEMA",valor:sistema}]:[]),
        ...(rucProveedor?[{nombre:"RUC PROVEEDOR",valor:rucProveedor}]:[])
      ]
    }
  };

  delete payload.numero_autorizacion;
  return payload;
}

export default function PrintInvoice({factura,authFetch,disabled=false}){
  const{dashboardTheme}=useDashboardTheme();
  const{showError,showSuccess}=useAlert();
  const[printing,setPrinting]=useState(false);

  const handlePrint=async()=>{
    if(!factura?.id||printing)return;
    setPrinting(true);
    try{
      const ticketResponse=await authFetch(`/api/facturacion/facturas/${factura.id}/ticket/`,{method:"GET"});
      const ticketData=await ticketResponse.json().catch(()=>null);
      if(!ticketResponse.ok||!ticketData?.ok||!ticketData?.factura){
        showError(ticketData?.error||"No se pudieron obtener los datos de la factura.");
        return;
      }

      const payload=normalizePrintData(ticketData.factura);

      const printResponse=await fetch(PRINT_INVOICE_ENDPOINT,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(payload)
      });

      const printData=await printResponse.json().catch(()=>({}));
      if(!printResponse.ok||!printData.ok){
        showError(printData.error||"No se pudo imprimir la factura.");
        return;
      }

      showSuccess("Factura enviada a impresión.");
    }catch{
      showError("No se pudo conectar con el puente de impresión local.");
    }finally{
      setPrinting(false);
    }
  };

  return(
    <Button
      variant="outlined"
      startIcon={printing?<CircularProgress size={18}/>:<PrintRoundedIcon/>}
      disabled={disabled||printing||!factura?.id}
      onClick={handlePrint}
      sx={{
        minHeight:42,
        borderRadius:"10px",
        textTransform:"none",
        fontWeight:700,
        borderColor:dashboardTheme.button_color,
        color:dashboardTheme.button_color,
        px:3,
        boxShadow:"none",
        "&:hover":{
          borderColor:dashboardTheme.button_hover_color,
          color:dashboardTheme.button_hover_color,
          boxShadow:"none"
        }
      }}
    >
      {printing?"Imprimiendo...":"Imprimir factura"}
    </Button>
  );
}